<template>
  <div class="header-banner">
    <nav role="navigation" class="navbar navbar-default navbar-fixed-top" style>
      <div class="container flex-center">
        <div class="pull-left">
          <a
            role="link"
            aria-label="Link to https://ontarionorthland.ca/"
            href="https://ontarionorthland.ca/"
            class="navbar-brand valigned"
          >
            <img
              alt="Ontario Northland Logo"
              src="../assets/logo-ontc-colour.png"
              class="logo"
            />
          </a>
        </div>
        <div class="navbar-collapse flex-container-right">
          <div class="flex-item user-nav text-center hidden-xs">
            <ul class="list-inline list-unstyled mrgn-tp-md">
              <template v-if="$i18n.locale === 'en'">
                <li><a href="https://www.ontarionorthland.ca/en/travel">Travel</a></li>
                <li><a href="https://www.ontarionorthland.ca/en/freight">Freight</a></li>
                <li><a href="https://www.ontarionorthland.ca/en/shipping">Parcel</a></li>
                <li><a href="https://www.ontarionorthland.ca/en/repair">Repair</a></li>
                <li><a href="https://www.ontarionorthland.ca/en/company">Company</a></li>
                <li><a href="https://www.ontarionorthland.ca/en/company/contact-us">Contact us</a></li>
              </template>
              <template v-if="$i18n.locale === 'fr'">
                <li><a href="https://www.ontarionorthland.ca/fr/voyager">Voyager</a></li>
                <li><a href="https://www.ontarionorthland.ca/fr/freight">Fret</a></li>
                <li><a href="https://www.ontarionorthland.ca/fr/shipping">Colis</a></li>
                <li><a href="https://www.ontarionorthland.ca/fr/repair">Réparation</a></li>
                <li><a href="https://www.ontarionorthland.ca/fr/entreprise">Entreprise</a></li>
                <li><a href="https://www.ontarionorthland.ca/fr/entreprise/nous-joindre">Nous joindre</a></li>
              </template>
            </ul>
          </div>
          <div class="flex-item user-nav text-center hidden-xs">
            <a href="#" @click.prevent="goToCart" class="btn btn-grey">
              <span v-if="hasCartItems"
                >{{ cart.items.tickets.length }}&nbsp;</span
              >
              <i class="fa fa-shopping-cart" aria-hidden="true"></i>
              <span class="sr-only">Cart</span>
            </a>
          </div>
          <div class="flex-item">
            <div class="flex-item user-nav text-center">
              <h2 class="sr-only" id="lang-selector">{{ $t('Language Selection') }}</h2>
              <ul
                  class="links list-inline list-unstyled"
                  id="lang-switcher"
                  aria-labelledby="lang-selector"
                >
                  <li
                    v-for="(lang, i) in langs"
                    :key="`Lang${i}`"
                    :data-lang="lang" 
                  >
                    <a
                      href="#"
                      :hreflang="lang"
                      @click.prevent="$i18n.locale = lang"
                      v-if="lang !== $i18n.locale"
                      >{{ language(lang) }}</a
                    >
                  </li>
                </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="site-section landing-page vertical-padding bg-img parallax" role="banner">
      <div class="container">
          <div class="row">
              <div class="col-xs-12 col-sm-8 col-lg-10">
                <template v-if="$i18n.locale === 'en'"><p class="heading-dot h1">Buy <span class="nowrap">Tickets<span class="dot"></span></span></p></template>
                <template v-if="$i18n.locale === 'fr'"><p class="heading-dot h1">Achat de <span class="nowrap">billets<span class="dot"></span></span></p></template>  
              </div>
          </div>
      </div>
  </div>
    <div class="breadcrumb container" role="navigation" aria-label="Breadcrumb">
      <ul class="list-inline">
        <li>
          <a href="/">{{ $t("bsearch") }}</a>
        </li>
        <li>
          <a :href="bTripUrl" :class="{ 'is-disabled': !hasTrips }">{{
            $t("btrips")
          }}</a>
        </li>
        <li>
          <a :href="bPassUrl" :class="{ 'is-disabled': !hasSelectedTrip }">{{
            $t("bpass")
          }}</a>
        </li>
      </ul>
    </div>
    <div class="operating-messages container">
      <div
        v-for="message in operationMessages"
        :key="message._id"
        class="alert alert-warning alert-dismissible"
        role="alert"
      >
        <span class="glyphicon glyphicon-alert" aria-hidden="true"></span>
        <button
          type="button"
          class="close"
          data-dismiss="alert"
          @click="dismissAlert(message._id)"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <strong class="sr-only">{{ message.type }}</strong>
        &nbsp;
        {{ message.message }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      langs: ["en", "fr"],
    };
  },
  computed: {
    hasTrips() {
      return "departures" in this.$store.state.trips;
    },
    hasSelectedTrip() {
      return this.$store.state.departureTripId;
    },
    bTripUrl() {
      return !this.hasTrips ? "#" : "/trips";
    },
    bPassUrl() {
      return !this.hasSelectedTrip ? "#" : "/trips/passengers";
    },
    hasCartItems() {
      if (Object.keys(this.cart).length) {
        return this.cart.items.tickets.length;
      } else {
        return false;
      }
    },
    ...mapState(["cart", "operationMessages"]),
  },
  methods: {
    language: function (lang) {
      switch (lang) {
        case "en":
          return "English";
        case "fr":
          return "Français";
      }
    },
    dismissAlert: function (messageId) {
      this.$store.dispatch("dismissOperationMessage", messageId);
    },
    goToCart: function () {
      this.$router.push("/cart");
    },
  },
  watch: {},
  mounted() {},
};
</script>
<style lang="scss">
.navbar-default {
  background-color: #fff !important;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.5);
  border-bottom:4px solid $brand-secondary;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .flex-container-right {
    flex: auto;
  }
}
.navbar-brand .logo {
  max-width: 250px;
  max-height: 70px;
}
.breadcrumb {
  background-color: transparent;
  color: $brand-primary;
  margin-top: 0px;
  margin-bottom: 0px;
  a {
    color: $brand-primary;
    font-size: 16px;
  }
  .is-disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  li {
    &:after {
      content: ">";
      padding-left: 10px;
    }
    &:last-child:after {
      content: "";
    }
  }
}
.flex-container-right {
  display: -webkit-box;
  -webkit-box-pack: end;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: end;
  justify-content: flex-end;
  align-items: center;
  .flex-item{
    vertical-align: middle;
  }
}
.flex-item {
  margin-top: auto;
  margin-bottom: auto;
}
.user-nav {
  //padding: 18px 0;
}
.banner-img {
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  height: 18vw;
  min-height: 150px;
}
.bg-img.parallax {
    background-position: 50% 100%;
    background-size: auto 130%;
}
  .site-section{
    .h1{
      text-transform: initial;
    }
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    text-shadow: 1px 1px 3px $gray-darker;
    
    &:before{
      content: "";
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: $gray-base;
      opacity: .18;
      z-index: 0;
    }

    .container{
      z-index: 1;
    }
    
    p.lead{
      font-weight: 500;
      margin-bottom: 0;
    }
    
    p.h1{
      margin: 0;
      color: $white;
      font-weight: 900;
      -webkit-text-stroke: 2px $white;
    }

    &.landing-page{
      min-height: 400px;
    }
    &.banner{
      min-height: 350px;
    }

    @media screen and (max-width: 768px){
      h1,
      .h1{
        font-size: 35px;
      }

      &.landing-page{
        min-height: 255px;
      }   
    }
    @media screen and (min-width: 768px){
      h1,
      .h1{
        font-size: 45px;
      }

      &.landing-page{
        min-height: 300px;
      }   
    }
  }
  .landing-page.site-section {
    background-position: 50% 100%;
    background-size: 105% auto;
    background-repeat: no-repeat !important;
    background-attachment: scroll !important;
    z-index: auto;
}
@media screen and (max-width: 767px){
  .landing-page.site-section > .container{
    width: 100%;
  }
  .landing-page.site-section {
    background-image:  url('../assets/banner-phone.jpeg') !important;
    background-repeat: no-repeat !important;
    background-attachment: scroll !important;
    z-index: auto;}
}
@media screen and (min-width: 768px){
  .landing-page.site-section {
    background-image:  url('../assets/banner-tablet.jpeg') !important;
    background-repeat: no-repeat !important;
    background-attachment: scroll !important;
    z-index: auto;}
}
@media screen and (min-width: 992px){
  .landing-page.site-section {
    background-image:  url('../assets/banner-tablet.jpeg') !important;
    background-repeat: no-repeat !important;
    background-attachment: scroll !important;
    z-index: auto;}
}
@media screen and (min-width: 1200px){
  .landing-page.site-section {
    background-image:  url('../assets/banner-desktop.jpeg') !important;
    background-repeat: no-repeat !important;
    background-attachment: scroll !important;
    z-index: auto;}
}

#lang-selector {
  display: flex;
  align-items: center;
  .curr-lang {
    padding: 0px 5px;
  }
  &:hover,
  &:focus {
    .lang-icon {
      color: #fff;
      fill: #fff;
    }
  }
}
.open .lang-icon {
  color: #fff;
  fill: #fff;
}
.alert-warning {
  background-color: #f0ad4e;
  color: #423016;
  font-size: 20px;
  padding: 20px;
}
.alert-info {
  font-size: 20px;
  padding: 20px;
}
.alert-dismissable .close,
.alert-dismissible .close {
  right: 0px;
}
#lang-switcher{
  margin-top:10px;
}
.navbar-default li a{
  color:$brand-primary;
  font-weight: 600;
}
.mrgn-tp-md{
  margin-top:10px;
}
.list-unstyled.mrgn-tp-md li a{
  margin-right: 15px;
}
</style>
